import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9003Handlers = [
  http.post(PlessService.SERVICE.getAuthoritySetList.url,
		async ({ request }) => {
			const req = await request.json();
			return HttpResponse.json(getAuthoritySetList);
			// return ResponseUtils.getSysError();
		}
	),
];

const getAuthoritySetList = {
	status: "ok",
	message: "処理終了",
	result: {
		obj: {
			AuthoritySetList: [
				{
					AuthoritySetId: "00",
					AuthoritySetName: "新規",
					AdminDiv: "0",
					AuthoritySetExplanation: "",
					AuthorityStatus: "1",
				},
				{
					AuthoritySetId: "01",
					AuthoritySetName: "あいう",
					AdminDiv: "1",
					AuthoritySetExplanation: "システム最上位権限",
					AuthorityStatus: "0",
				},
				{
					AuthoritySetId: "01",
					AuthoritySetName: "アイウエオ",
					AdminDiv: "0",
					AuthoritySetExplanation: "コープデリ一般社員用権限",
					AuthorityStatus: "1",
				},
				{
					AuthoritySetId: "00",
					AuthoritySetName: "ｱｲｳｴｵ",
					AdminDiv: "1",
					AuthoritySetExplanation: "システム最上位権限",
					AuthorityStatus: "0",
				},
				{
					AuthoritySetId: "99",
					AuthoritySetName: "削除",
					AdminDiv: "0",
					AuthoritySetExplanation: "論理削除",
					AuthorityStatus: "0",
				},
			]
		}
	}
}

